__turbopack_context__.v({
  "buttonSpacer": "pagination-controls-module-scss-module__4p80mG__buttonSpacer",
  "pageControls": "pagination-controls-module-scss-module__4p80mG__pageControls",
  "paginationButton": "pagination-controls-module-scss-module__4p80mG__paginationButton",
});
